import React, { useCallback, useMemo } from "react";
import { Button, IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";
import {
  Add,
  Info,
  OpenInNew as OpenInNewIcon,
  Edit,
} from "@mui/icons-material";
import copy from "./../../assets/CRMAssets/ic_duplicate_grey@2x.png";
import { Tooltip, Typography } from "@mui/material";
import styles from "./Styles.module.css";
import DataTables from "./../../Datatables/Datatable.table";
import Constants from "./../../config/constants";
import FilterComponent from "./../../components/Filter/Filter.component";
import useHealthTipsListHook from "./HealthTipsListHook";
import capitalizeFirstLetter from "./../../hooks/CommonFunction";
import { ArrowPrimaryButton } from "./../../components/Buttons/PrimaryButton";
import StatusPill from "./../../components/Status/StatusPill.component";
import ShadowBox from "../../components/ShadowBox/ShadowBox";
import useRoles from "../../hooks/RoleHook";

const HealthTipsList = () => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    handleDetail,
    handleFilterDataChange,
    handleSearchValueChange,
    handleProfile,
    configFilter,
    handleCreate,
    handleEdit,
    handleCopy,
  } = useHealthTipsListHook({});
  const {canDelete, canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.HEALTH_TIPS_MASTER);
  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.health);

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.title)}`} </div>
        </div>
      </div>
    );
  }, []);

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    } else if (status === "SCHEDULED") {
      return <StatusPill status={"Scheduled"} color={"medium"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "title",
        label: "Title",
        sortable: false,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },
      {
        key: "",
        label: "Client",
        sortable: false,
        render: (value, all) => (
          <div>{capitalizeFirstLetter(all?.client?.name)}</div>
        ),
      },

      {
        key: "time",
        label: "Timestamp of pushing on app",
        sortable: false,
        render: (temp, all) => <div>{all?.startDateText}</div>,
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all.status)}</div>,
      },

      {
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
             {canRead &&
              <span className={styles.info}>
              <Tooltip
                title={<>View Detail</>}
                aria-label="info"
                placement="right"
                className={styles.infoTip}
              >
             <IconButton
              onClick={(e) => {
                handleDetail(all);
              }}
               disableRipple="false"
               className={styles.icon}
            >
              <Info fontSize={"small"} />
            </IconButton>
            </Tooltip>
                </span>
            }
            {canUpdate &&
            <Tooltip
            title={<>Edit Content</>}
            aria-label="info"
            placement="right"
            className={styles.infoTip}
          >
            <IconButton
              onClick={(e) => {
                handleEdit(all);
              }}
               disableRipple="false"
            >
              <Edit fontSize={"small"} />
            </IconButton>
            </Tooltip>
            }
            {/* <IconButton
              disableRipple="false"
              onClick={() => handleCopy(all)}
            >
              <img src={copy} alt="copy" className={styles.copy} />
            </IconButton> */}
          </div>
        ),
      },
    ],
    [renderFirstCell, renderStatus, handleDetail, handleProfile]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEdit,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    present,
    currentPage,
  ]);

  return (
    <ShadowBox className={styles.contact}>
      <div className={styles.headerContainer}>
        <Typography
          variant={"h5"}
          color={"text.primary"}
          className={styles.title}
        >
          Health & Wellness Tips
        </Typography>
        {canCreate && <ArrowPrimaryButton
          onClick={handleCreate}
          icon={<Add fontSize="normal" />}
        >
          ADD HEALTH TIPS
        </ArrowPrimaryButton>}
      </div>

      <div>
        <FilterComponent
          is_progress={isFetching}
          filters={configFilter}
          handleSearchValueChange={handleSearchValueChange}
          handleFilterDataChange={handleFilterDataChange}
          placeholder="Search by title"
        />
        <div>
          <br />
          <div style={{ width: "100%" }}>
            <DataTables
              {...tableData.datatable}
              {...tableData.datatableFunctions}
              //shadow={true}
            />
          </div>
        </div>
      </div>
    </ShadowBox>
  );
};

export default HealthTipsList;
